import { default as uuidV4 } from 'uuid/v4';

export default class Event {
  public readonly id: string = uuidV4();
  public readonly externalId?: string;
  public readonly type: string;
  public readonly revision: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readonly dimensions: Record<string, any>;
  public readonly timestamp = new Date();
  public readonly ntpTimestamp = new Date();

  public constructor(
    id: string,
    type: string,
    typeRevision: number,
    dimensions: object,
    ntpTimeStamp: Date,
    externalId?: string
  ) {
    this.id = id || uuidV4();
    this.externalId = externalId;
    this.type = type;
    this.revision = typeRevision;
    this.dimensions = dimensions;
    this.ntpTimestamp = ntpTimeStamp;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public toObject(): Record<string, any> {
    return {
      eventId: this.id,
      eventType: this.type,
      eventTypeRevision: this.revision,
      dimensions: this.dimensions,
      localTimestamp: this.timestamp,
      ntpLocalTimestamp: this.ntpTimestamp,
    };
  }
}
